import {useEnvironment} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useSettings} from '../../../../hooks/settings'
import settingsParams from '../../../../settingsParams'
import {Subtitle} from '../../subtitle/subtitle'
import {SocialShare} from '../index'
import {SocialShareProps} from '../interfaces'
import ss from '../social-share.scss'
import s from './with-title.scss'

export const SocialShareWithTitle = ({page}: SocialShareProps) => {
  const settings = useSettings()
  const {isMobile} = useEnvironment()

  const shareTitleText = settings.get(settingsParams.shareTitleText)

  return (
    <div className={s.container}>
      <Subtitle className={isMobile ? s.subtitle : null} dataHook="social-share" text={shareTitleText} />
      <div className={ss.container}>
        <SocialShare page={page} />
      </div>
    </div>
  )
}
